import classNames from 'classnames';
import React from 'react';
import { CloseIcon } from 'tdesign-icons-react';
import { Button, Space } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { Star2 } from '@/components/icon';

import styles from './index.module.less';

interface IProps {
  newPrompt: string;
  visible: boolean;
  onClose: () => void;
  onConfirm: (confirmed: boolean) => void;
  handleGenerate: () => void;
}

const PolishPromptDialog: React.FC<IProps> = ({ newPrompt, visible, onClose, onConfirm, handleGenerate }) => {
  const handleConfirm = () => {
    onConfirm(true);
    onClose();
  };

  const getHeader = () => (
    <div className={styles.title}>
      <div className={styles.left}>
        <Star2 />描述润色
      </div>
      <CloseIcon onClick={onClose} style={{ cursor: 'pointer' }} />
    </div>
  );

  const getFooter = () => (
    <div className={classNames('nova-modal-fixed-bottom-wrapper-end', styles.footer)}>
      <Space size={10}>
        <Button
          className="nova-info-button"
          size="medium"
          block
          theme="default"
          onClick={handleGenerate}
        >
          重新生成
        </Button>
        <Button
          className="nova-info-button"
          size="medium"
          block
          onClick={handleConfirm}
        >
          使用
        </Button>
      </Space>
    </div>
  );

  const dialogConfig = {
    visible,
    className: styles.dialog,
    style: { padding: 0 },
    closeBtn: false,
    header: getHeader(),
    footer: getFooter(),
    destroyOnClose: true,
  };

  return (
    <NovaDialog dialogConfig={dialogConfig}>
      <div className={styles.content}>{newPrompt}</div>
    </NovaDialog>
  );
};

export default PolishPromptDialog;
